import React, { useContext, useEffect, useMemo } from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import TabNav from '../../ui/TabNav/TabNav'
import { AuthContext } from '../../App'
import MarketingLinks from './Links/MarketingLinks'
import MarketingPromos from './Promos/MarketingPromos'
import MarketingAmeCampaigns from './AmeCampaigns/MarketingAmeCampaigns'
import MarketingGifts from './Gifts/MarketingGifts'
import MarketingPlaceholder from './MarketingPlaceholder'
import PromoSchedulesSyncButton from '../../api/marketing/PromoSchedulesSyncButton'
import { isMarketingOnlyUser, canManageAmeCampaigns } from '../../config/accessControl'
import './Marketing.sass'

const ALL_TAB_LINKS = [
  { title: 'Акції дистриб’юторів', path: '/marketing/promos' },
  { title: 'Акції Ame', path: '/marketing/ame' },
  { title: 'Посилання / UTM', path: '/marketing/utm' },
  { title: 'Подарунки', path: '/marketing/gifts' },
  { title: 'Банери', path: '/marketing/banners' },
  { title: 'Фіди', path: '/marketing/feeds' },
]

const MARKETING_ONLY_TAB_PATHS = ['/marketing/promos', '/marketing/utm']

function Marketing() {
  const { setPageTitle, user } = useContext(AuthContext)
  const { pathname } = useLocation()
  const marketingOnly = isMarketingOnlyUser(user?.uid)
  const showAmeCampaigns = canManageAmeCampaigns(user)
  const showPromoSync = pathname.startsWith('/marketing/promos') && !marketingOnly

  const tabLinks = useMemo(() => {
    const visible = marketingOnly
      ? ALL_TAB_LINKS.filter((tab) => MARKETING_ONLY_TAB_PATHS.includes(tab.path))
      : ALL_TAB_LINKS

    if (showAmeCampaigns) {
      return visible
    }

    return visible.filter((tab) => tab.path !== '/marketing/ame')
  }, [marketingOnly, showAmeCampaigns])

  useEffect(() => {
    setPageTitle('Маркетинг')
  }, [setPageTitle])

  return (
    <>
      <TabNav links={tabLinks} buttons={showPromoSync ? <PromoSchedulesSyncButton /> : null} />
      <div className="Marketing">
        <Switch>
          <Route exact path="/marketing/list" render={() => <Redirect to="/marketing/promos" />} />
          <Route exact path="/marketing" render={() => <Redirect to="/marketing/promos" />} />
          <Route exact path="/marketing/promos" component={MarketingPromos} />
          {showAmeCampaigns ? (
            <Route path="/marketing/ame" component={MarketingAmeCampaigns} />
          ) : (
            <Route path="/marketing/ame" render={() => <Redirect to="/marketing/promos" />} />
          )}
          <Route path="/marketing/utm" component={MarketingLinks} />
          {marketingOnly ? (
            <>
              <Route path="/marketing/gifts" render={() => <Redirect to="/marketing/promos" />} />
              <Route path="/marketing/banners" render={() => <Redirect to="/marketing/promos" />} />
              <Route path="/marketing/feeds" render={() => <Redirect to="/marketing/promos" />} />
            </>
          ) : (
            <>
              <Route path="/marketing/gifts" component={MarketingGifts} />
              <Route
                path="/marketing/banners"
                render={() => <MarketingPlaceholder title="Банери" phase={3} />}
              />
              <Route path="/marketing/feeds" render={() => <MarketingPlaceholder title="Фіди" phase={5} />} />
            </>
          )}
          <Route render={() => <Redirect to="/marketing/promos" />} />
        </Switch>
      </div>
    </>
  )
}

export default Marketing
